var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFedespedi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 275,
    viewBox: "0 0 347 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.376 185.927C67.6985 172.076 0.0944824 144.872 0.0944824 84.1914C0.0944824 7.63827 123.938 -4.81657 285.337 2.19958C271.156 1.58321 210.965 9.46236 159.172 43.4974C94.4316 86.0412 103.68 128.585 144.376 185.927Z",
    fill: "#074A7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.718 89.0726C279.396 102.924 347 130.129 347 190.809C347 267.362 223.157 279.817 61.7574 272.8C75.9387 273.417 136.13 265.538 187.922 231.503C252.663 188.959 243.414 146.415 202.718 89.0726Z",
    fill: "#074A7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFedespedi);
export default __webpack_public_path__ + "static/media/logo_fedespedi.53574b9f173eb27d37ec0dbf935cf797.svg";
export { ForwardRef as ReactComponent };